import React, { useCallback, useMemo } from 'react';
import FeedbackIcon from '@atlaskit/icon/core/feedback';
import { IconButton } from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';
import { useFeedbackCollectorActions } from '@atlassian/jira-feedback-collector/src/controllers/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import {
	ENTRY_POINT_ID_INDIVIDUAL_CAPACITY_PLANNING,
	EntryKeys,
} from '@atlassian/jira-feedback-collector/src/constants.tsx';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import messages from './messages.tsx';

// These routes will show the global fullscreen button, others won't
export const CAPACITY_FEEDBACK_ROUTES: RouteName[] = [
	'software-capacity',
	'software-capacity-classic',
	'classic-business-capacity',
];

export const FeedbackButton = ({ routeName }: { routeName: string }): React.JSX.Element => {
	const { openFeedbackCollector } = useFeedbackCollectorActions();
	const { formatMessage } = useIntl();
	const cloudId = useCloudId();

	const feedbackContext = useMemo(
		() => [
			{ id: EntryKeys.CLOUD_ID, value: cloudId },
			{ id: EntryKeys.ROUTE_NAME, value: routeName },
		],
		[cloudId, routeName],
	);

	const handleFeedbackClick = useCallback(
		() =>
			openFeedbackCollector({
				entrypointId: ENTRY_POINT_ID_INDIVIDUAL_CAPACITY_PLANNING,
				feedbackContext,
			}),
		[openFeedbackCollector, feedbackContext],
	);

	return (
		<Tooltip content={formatMessage(messages.title)}>
			<IconButton
				testId="capacity.ui.feedback-button.feedback-button"
				onClick={handleFeedbackClick}
				icon={FeedbackIcon}
				label={formatMessage(messages.title)}
			/>
		</Tooltip>
	);
};
